export default {
  landing: {
    pageTitle: 'Hostinator — Servere de jocuri și hosting custom',
    badge: 'Pregătim lansarea publică',
    title: 'Tu aduni prietenii.',
    highlight: 'Noi găzduim jocul.',
    description: 'Pregătim hosting pentru Minecraft, Valheim și multe alte jocuri, disponibile odată cu lansarea site-ului. Hostingul custom este disponibil la cerere.',
    contact: 'Hai să vorbim',
    explore: 'Descoperă hostingul',
    notice: 'Lucrăm la noul site. Pentru detalii despre lansare sau o soluție custom, scrie-ne. Serviciile existente continuă să funcționeze.',
    visualLabel: 'La lansarea site-ului',
    minecraftTag: 'Construiește o lume împreună',
    valheimTag: 'Pornește în aventură cu prietenii',
    exilTag: 'Deja găzduit prin Hostinator',
    more: 'multe alte jocuri',
    wishlist: 'Adaugă în wishlist pe Steam',
    visualFooter: 'JOCUL TĂU. COMUNITATEA TA. HOSTINGUL NOSTRU.',
    gamesEyebrow: 'În curând',
    gamesTitle: 'Jocurile tale, la lansarea site-ului.',
    gamesIntro: 'Minecraft, Valheim și multe alte jocuri vor fi disponibile când lansăm site-ul.',
    minecraftDescription: 'O lume pentru tine și comunitatea ta. Hosting Minecraft pentru construcții, explorare și aventuri împreună.',
    valheimDescription: 'Un loc pentru clanul tău. Explorează, construiește și cucerește lumea Valheim alături de prieteni.',
    moreGamesTitle: '+ multe alte jocuri',
    moreGamesDescription: 'Pregătim o gamă mai largă de servere de jocuri, disponibilă odată cu lansarea site-ului.',
    customTitle: 'Hosting custom, la cerere',
    customDescription: 'Dezvolți propriul joc sau ai un proiect cu cerințe speciale? Putem pregăti o soluție de hosting personalizată chiar de acum.',
    exilProof: 'Exil Island este deja găzduit prin Hostinator.',
    exilDescription: 'Descoperă jocul pe Steam și susține-l cu un wishlist.',
    contactTitle: 'Ce vrei să aduci online?',
    contactDescription: 'Ai întrebări despre lansare sau ai nevoie de hosting custom? Povestește-ne ce ai în plan.',
    footer: 'Hosting pentru jocuri și proiecte custom.',
    loginHint: 'Ai nevoie de acces? Contactează-ne la',
    menuToggle: 'Deschide sau închide meniul',
  },
  // Common
  common: {
    loading: 'Se încarcă...',
    error: 'Eroare',
    cancel: 'Anulează',
    save: 'Salvează',
    delete: 'Șterge',
    create: 'Creează',
    edit: 'Editează',
    close: 'Închide',
    refresh: 'Reîncarcă',
    search: 'Caută',
    back: 'Înapoi',
    or: 'sau',
    yes: 'Da',
    no: 'Nu',
    all: 'Toate',
    active: 'Activ',
    inactive: 'Inactiv',
    online: 'Online',
    offline: 'Offline',
    live: 'Live',
    connected: 'Conectat',
    players: 'Jucători',
    version: 'Versiune',
    status: 'Status',
    details: 'Detalii',
    actions: 'Acțiuni',
    free: 'Gratuit',
    copied: 'Copiat!',
  },

  // Navbar
  nav: {
    home: 'Acasă',
    dashboard: 'Panou de control',
    admin: 'Admin',
    login: 'Autentificare',
    getStarted: 'Începe acum',
    logout: 'Deconectare',
  },

  // Home Page
  home: {
    badge: 'Server gata în 2 minute',
    heroTitle: 'Servere de jocuri,',
    heroHighlight: 'simplificate.',
    heroSubtitle: 'Găzduiește-ți serverul de Minecraft instant. Fără configurare, fără bătăi de cap.',
    startFree: 'Începe gratuit',
    viewPlans: 'Vezi planurile',
    whyUs: 'De ce Hostinator?',
    whyUsSubtitle: 'Creat de gameri, pentru gameri.',
    features: {
      instantSetup: 'Configurare instantă',
      instantSetupDesc: 'Server online în sub 2 minute.',
      highPerformance: 'Performanță ridicată',
      highPerformanceDesc: 'Hardware premium, zero lag.',
      ddosProtected: 'Protecție DDoS',
      ddosProtectedDesc: 'Serverul tău rămâne online.',
      support: 'Suport 24/7',
      supportDesc: 'Ajutor când ai nevoie.',
    },
    pickPlan: 'Alege planul tău',
    pickPlanSubtitle: 'Începe gratuit. Fă upgrade oricând.',
    popular: 'POPULAR',
    perMonth: 'RON/lună',
    ram: 'RAM',
    maxPlayers: 'jucători',
    readyToPlay: 'Gata de joacă?',
    readyToPlaySubtitle: 'Alătură-te miilor de gameri care găzduiesc cu Hostinator.',
    createFreeServer: 'Creează server gratuit',
    footer: '© 2026 Hostinator. Creat pentru gameri.',
    footerTagline: 'Fiecare server vine cu propriul lui -inator.',
    // Package features
    packageFeatures: {
      autoShutdown: 'Oprire automată',
      basicSupport: 'Suport de bază',
      limitedFiles: 'Fișiere limitate',
      fullFileAccess: 'Acces complet la fișiere',
      allVersions: 'Toate versiunile',
      plugins: 'Plugin-uri',
      uptime247: 'Funcționare 24/7',
      customSubdomain: 'Subdomeniu personalizat',
      prioritySupport: 'Suport prioritar',
      autoBackups: 'Backup-uri automate',
      ssdStorage: 'Stocare SSD',
      premiumLocation: 'Locație premium',
      dedicatedSupport: 'Suport dedicat',
    },
  },

  // Login Page
  login: {
    title: 'Bine ai revenit',
    newHere: 'Ești nou?',
    createAccount: 'Creează cont',
    email: 'Email',
    password: 'Parolă',
    signIn: 'Autentificare',
    continueGoogle: 'Continuă cu Google',
    continueDiscord: 'Continuă cu Discord',
    failed: 'Autentificarea a eșuat',
  },

  // Register Page
  register: {
    title: 'Creează cont',
    haveAccount: 'Ai deja cont?',
    signIn: 'Autentifică-te',
    name: 'Nume',
    namePlaceholder: 'Numele tău',
    email: 'Email',
    password: 'Parolă',
    confirmPassword: 'Confirmă parola',
    createAccount: 'Creează cont',
    continueGoogle: 'Continuă cu Google',
    continueDiscord: 'Continuă cu Discord',
    terms: 'Prin crearea contului, ești de acord cu Termenii și Politica de Confidențialitate.',
    failed: 'Înregistrarea a eșuat',
    passwordMismatch: 'Parolele nu coincid',
  },

  // Dashboard
  dashboard: {
    title: 'Panou de control',
    greeting: 'Salut {{name}}!',
    newServer: 'Server nou',
    noServers: 'Niciun server încă',
    noServersDesc: 'Creează primul tău server pentru a începe',
    createServer: 'Creează server',
    serverAddress: 'Adresă server',
    loadServersError: 'Serverele tale nu au putut fi încărcate',
    loadPackagesError: 'Pachetele disponibile nu au putut fi încărcate',
    retry: 'Reîncearcă',
    noPackages: 'Nu există niciun pachet Minecraft sau Valheim activ. Cere unui administrator să publice unul.',
  },

  // Server Card
  serverCard: {
    players: 'Jucători',
    ram: 'RAM',
    cpu: 'Limită CPU',
    storage: 'Stocare',
    version: 'Versiune',
    serverAddress: 'Adresă server',
    dnsPending: 'DNS în așteptare',
    viewDetails: 'Detalii',
    autoShutdownScheduled: 'Oprire automată programată la {{time}}.',
    autoShutdownWaiting: 'Oprirea automată așteaptă {{minutes}} minute fără jucători.',
    autoShutdownEnabled: 'Oprirea automată este activă ({{minutes}} minute idle).',
  },

  // Server statuses
  serverStatus: {
    running: 'pornit',
    stopped: 'oprit',
    creating: 'se creează',
    starting: 'pornește',
    stopping: 'se oprește',
    restarting: 'se repornește',
    deleting: 'se șterge',
    error: 'eroare',
    suspended: 'suspendat',
  },

  serverOperation: {
    phases: {
      preparing_server_data: 'Se pregătesc datele serverului',
      selecting_host: 'Se selectează o gazdă disponibilă',
      moving_server: 'Serverul este mutat',
      starting: 'Serverul pornește',
    },
    errors: {
      no_start_placement_available: 'Nu există momentan nicio gazdă eligibilă. Încearcă din nou mai târziu.',
      server_data_not_ready: 'Datele serverului nu sunt încă pregătite. Așteaptă finalizarea pregătirii și încearcă din nou.',
      generic: 'Serverul nu a putut fi pornit. Încearcă din nou sau contactează suportul dacă problema continuă.',
    },
  },

  // Server Details Page
  serverDetails: {
    notFound: 'Server negăsit',
    notFoundDesc: 'Serverul nu există.',
    backToDashboard: 'Înapoi la Panou',
    onlinePlayers: 'Jucători online',
    connection: 'Conexiune',
    serverAddress: 'Adresă server',
    directIp: 'IP Direct',
    dnsPending: 'DNS în așteptare',
    details: 'Detalii',
    package: 'Pachet',
    legacyPackage: 'Pachet legacy',
    runtime: 'Runtime',
    specHash: 'Hash spec aplicat',
    memoryLimit: 'RAM aplicat',
    cpuLimit: 'CPU aplicat',
    storageLimit: 'Stocare aplicată',
    maxPlayersLimit: 'Limită jucători aplicată',
    version: 'Versiune',
    serverType: 'Tip server',
    difficulty: 'Dificultate',
    mode: 'Mod',
    motd: 'MOTD',
    created: 'Creat',
    container: 'Container',
    actions: 'Acțiuni',
    start: 'Pornește',
    stop: 'Oprește',
    restart: 'Repornește',
    files: 'Fișiere',
    dockerLogs: 'Docker Logs',
    minecraftConsole: 'Minecraft Console',
    delete: 'Șterge',
    host: 'Gazdă',
    agent: 'Agent',
    region: 'Regiune',
    containers: 'Containere',
    updated: 'Actualizat la',
    ramAllocated: 'RAM alocat',
    game: 'Joc',
    loadFailed: 'Serverul nu a putut fi încărcat.',
    retryLoad: 'Reîncearcă',
    refreshFailed: 'Starea recentă a serverului nu a putut fi reîncărcată.',
    operationRejected: 'Comanda nu a fost acceptată',
    retryableError: 'Eroarea permite reîncercare. Reîncarcă starea și încearcă din nou când operația devine disponibilă.',
    serverError: 'Serverul necesită atenție',
    operationInProgress: 'Operația {{operation}} este în curs',
    waitForCompletion: 'Cererea a fost acceptată. Se așteaptă finalizarea operației durabile.',
    retryScheduled: 'Reîncercare automată planificată la {{time}}.',
    provisioning: 'Serverul se configurează...',
    starting: 'Serverul pornește...',
    operationPhase: '{{operation}} · {{phase}}',
    deleteConfirm: 'Ștergi „{{name}}”? Serverul, world-ul și DNS-ul vor fi eliminate după confirmarea Agentului.',
    actionFailed: 'Operația {{action}} a eșuat.',
    actionAccepted: 'Cererea {{action}} a fost acceptată.',
    autoShutdownTitle: 'Oprire automată activă',
    autoShutdownScheduled: 'Nu sunt jucători conectați. Serverul se va opri la {{time}}, după {{minutes}} minute idle.',
    autoShutdownWaiting: 'Serverul va fi programat pentru oprire după {{minutes}} minute fără jucători, când monitoring-ul fresh confirmă starea idle.',
    autoShutdownEnabled: 'Politica se va aplica după pornirea serverului: {{minutes}} minute fără jucători.',
  },

  dockerLogs: {
    title: 'Docker Logs — {{name}}',
    older: 'Mai vechi',
    clear: 'Golește local',
    autoScroll: 'Derulare automată',
    manualScroll: 'Derulare manuală',
    retry: 'Reîncearcă',
    empty: 'Nu există Docker logs disponibile',
    lineCount: '{{count}} linii',
    live: 'Live',
    snapshotOnly: 'Doar snapshot',
    loadFailed: 'Docker logs nu au putut fi încărcate',
    olderFailed: 'Docker logs mai vechi nu au putut fi încărcate',
    liveFailed: 'Stream-ul live Docker logs a eșuat',
  },

  minecraftConsole: {
    title: 'Minecraft Console — {{name}}',
    clear: 'Golește transcriptul local',
    empty: 'Nu există comenzi în această sesiune locală.',
    placeholder: 'Introdu o comandă Minecraft…',
    commandLabel: 'Comandă Minecraft',
    send: 'Trimite',
    sending: 'Se trimite o singură dată…',
    noOutput: '(Fără output)',
    duration: '{{duration}} ms',
    truncated: 'output trunchiat',
    historyHint: 'Enter trimite o singură dată. Folosește ↑ și ↓ pentru istoricul local.',
    errors: {
      timeout: 'Comanda Minecraft a expirat. Nu a fost retrimisă.',
      resultUnknown: 'Comanda poate să fi rulat, dar rezultatul este necunoscut. Nu a fost retrimisă.',
      agentOffline: 'Host-Agentul este offline. Minecraft Console nu este disponibilă.',
      serverStopped: 'Pornește serverul Minecraft înainte de a trimite o comandă.',
      serverBusy: 'O altă operație a serverului este în curs. Așteaptă finalizarea ei.',
      unsupported: 'Runtime-ul pin-uit nu suportă Minecraft Console.',
      rconUnavailable: 'Minecraft RCON nu este disponibil în serverul pornit.',
      unavailable: 'Minecraft Console nu este disponibilă.',
    },
  },

  backups: {
    title: 'Backup-uri',
    retention: 'Se păstrează ultimele {{count}} backup-uri finalizate.',
    create: 'Creează backup',
    operationActive: 'O operație de backup sau restaurare este în curs',
    empty: 'Nu există backup-uri.',
    restore: 'Restaurează peste serverul curent',
    restoreConfirmTitle: 'Înlocuiești datele serverului curent?',
    restoreConfirmWarning: 'Datele curente vor fi înlocuite definitiv cu acest backup. Serverul va fi oprit controlat și va fi repornit automat dacă era pornit.',
    restoreConfirm: 'Confirmă restaurarea',
    latestRestore: 'Ultima restaurare',
    restorePending: 'În așteptare',
    restoreInProgress: 'În curs',
    restoreSucceeded: 'Finalizată',
    restoreFailedStatus: 'Eșuată',
    restorePhase: 'Fază: {{phase}}',
    restoreAttempts: 'Încercări: {{count}}',
    restoreRetryAt: 'Următoarea încercare: {{time}}',
    download: 'Descarcă',
    loadFailed: 'Backup-urile nu au putut fi încărcate.',
    createFailed: 'Cererea de backup a eșuat.',
    restoreFailed: 'Cererea de restore a eșuat.',
    downloadFailed: 'Backup-ul nu a putut fi descărcat.',
  },

  // Create Server Modal
  createServer: {
    settingsLoading: 'Setările pachetului încă se încarcă.',
    settingsLoadError: 'Setările pachetului nu au putut fi încărcate.',
    noPackagesForGame: 'Nu există niciun pachet activ pentru acest joc.',
    createFailed: 'Serverul nu a putut fi creat.',
    noCpuCapacity: 'Niciun VPC eligibil nu are momentan suficientă capacitate CPU rezervabilă pentru acest pachet. Eliberează resurse sau încearcă mai târziu.',
    noMemoryCapacity: 'Niciun VPC eligibil nu are momentan suficientă capacitate RAM rezervabilă pentru acest pachet. Eliberează resurse sau încearcă mai târziu.',
    noStorageCapacity: 'Niciun VPC eligibil nu are momentan suficientă capacitate de stocare rezervabilă pentru acest pachet. Eliberează resurse sau încearcă mai târziu.',
    noWeightCapacity: 'Capacitatea weight configurată pentru pachete este ocupată pe toate VPC-urile eligibile.',
    noPackageCapacity: 'Limita de instanțe a pachetului este atinsă pe toate VPC-urile eligibile.',
    noPortCapacity: 'Niciun VPC eligibil nu are momentan porturile host necesare pentru acest server.',
    noGenericCapacity: 'Niciun VPC eligibil nu are momentan toate resursele rezervabile și porturile host necesare acestui pachet.',
    invalidCreateResponse: 'Serverul a fost acceptat, dar identificatorul lui lipsește din răspuns.',
    sensitiveDefaultPlaceholder: 'Lasă gol pentru valoarea implicită configurată',
    sensitiveDefaultHelp: 'Există o valoare implicită configurată. Lasă câmpul gol pentru a o folosi.',
    title: 'Server nou',
    serverDetails: 'Detalii server',
    subdomain: 'Subdomeniu',
    subdomainHelp: '{{name}}.hostinator.ro',
    displayName: 'Nume afișat',
    displayNamePlaceholder: 'Serverul meu super',
    selectPackage: 'Alege pachetul',
    settings: 'Setări',
    subdomainError: 'Subdomeniu: doar litere mici, cifre și cratime',
    selectPackageError: 'Selectează un pachet',
    subdomainTaken: 'Subdomeniului este deja ocupat',
    invalidSubdomain: 'Subdomeniu invalid',
    creating: 'Se creează...',
    createServer: 'Creează server',
  },

  // Admin Page
  admin: {
    title: 'Admin',
    subtitle: 'Administrare platformă',
    vpcs: 'VPC-uri',
    packages: 'Pachete',
    commands: 'Comenzi',
    vpcManagement: 'Gestionare VPC-uri',
    addVpc: 'Adaugă VPC',
    filterStatus: 'Status',
    filterName: 'Nume',
    filterProvider: 'Furnizor',
    filterIp: 'Adresă IP',
    searchName: 'Caută nume...',
    searchProvider: 'Furnizor...',
    searchIp: 'Adresă IP...',
    tableStatus: 'Status',
    tableName: 'Nume',
    tableAddress: 'Adresă',
    tableSpecs: 'Specificații',
    tableUsage: 'Utilizare',
    tableActions: 'Acțiuni',
    noVpcs: 'Niciun VPC găsit',
    totalVpcs: '{{count}} VPC-uri total',
    cores: 'nuclee',
    storage: 'stocare',
    containers: 'containere',
    unknown: 'Necunoscut',
  },

  // Maintenance page
  maintenance: {
    title: 'Site în lucru',
    subtitle: 'Lucrăm la ceva măreținator!',
    description: 'Hostinator-ul este în curs de pregătire. Revino în curând pentru cea mai tare experiență de hosting!',
    checkBack: 'Verifică din nou mai târziu',
  },

  // Games Page
  games: {
    badge: 'Jocuri suportate',
    title: 'Jocuri disponibile',
    subtitle: 'Hostinator suportă mai multe jocuri, cu altele noi în drum. Votează pentru jocul tău preferat!',
    supportedTitle: 'Disponibile acum',
    available: 'Disponibil',
    upcomingTitle: 'În curând',
    upcomingSubtitle: 'Aceste jocuri vor fi suportate în curând. Votează pentru a grăbi procesul!',
    comingSoon: 'În curând',
    votes: 'voturi',
    vote: 'Votează',
    voted: 'Votat',
    voteInfo: 'Poți vota o dată pe zi pentru fiecare joc. Autentifică-te pentru a vota.',
  },

  // Home game selector
  homeGames: {
    selectGame: 'Alege jocul',
    minecraft: 'Minecraft',
    valheim: 'Valheim',
  },

  // Create server game step
  createServerGame: {
    chooseGame: 'Alege jocul',
    chooseGameSubtitle: 'Selectează jocul pentru care vrei să creezi un server',
  },

  // Nav
  navGames: {
    games: 'Jocuri',
  },
} as const;
